import { ApiEnumName } from "@/common/services/enum";
import { VehicleStatus } from "@/core/api/generated/v1";

import { StatusDisplay, StatusDisplayProps } from "../../../../Status/StatusDisplay";
import GeneralStatusEnumValueInline, {
  GeneralStatusEnumValueInlineProps,
} from "../GeneralStatusEnumValueInline";
import { VehicleStatusIndicator } from "./VehicleStatusIndicator";

interface Props {
  status: VehicleStatus | undefined;
  statusProps?: Partial<StatusDisplayProps>;
  enumInlineProps?: Partial<GeneralStatusEnumValueInlineProps>;
}

export function VehicleStatusDisplay({ status, statusProps, enumInlineProps }: Props) {
  return (
    <StatusDisplay
      title={
        <GeneralStatusEnumValueInline
          statusEnumTypeName={ApiEnumName.VehicleStatus}
          status={status}
          {...enumInlineProps}
        />
      }
      indicator={<VehicleStatusIndicator status={status} />}
      {...statusProps}
    />
  );
}
